var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 27,
    viewBox: "0 0 35 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 27H35V0H0V27ZM2.05882 2.77062V2.0769H32.9412V2.77061L17.5 16.2789L2.05882 2.77061V2.77062ZM32.9412 5.52047V22.9999L26.5403 14.9289L24.9303 16.2249L31.8274 24.9231H3.17264L10.0697 16.2249L8.4597 14.9289L2.05882 22.9999V5.52047L17.5 19.0288L32.9412 5.52047H32.9412Z",
    fill: "#000064"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSvg);
export default __webpack_public_path__ + "static/media/emailSvg.d4e292ca5b24e7e455a388f2c85e3a54.svg";
export { ForwardRef as ReactComponent };